// API Configuration
export const API_REQUEST_TIMEOUT_MS = 15_000; // 15 seconds
export const AUTH_REQUEST_TIMEOUT_MS = 10_000; // 10 seconds

// React Query Configuration
export const QUESTIONS_QUERY_STALE_TIME_MS = 30_000; // 30 seconds
export const TOPICS_QUERY_STALE_TIME_MS = 60_000; // 60 seconds

// Pagination
export const MAX_PAGINATION_ITERATIONS = 50;
export const DEFAULT_PAGE_SIZE = 30;

// Account Deletion
export const ACCOUNT_DELETION_CONFIRM_PHRASE = 'VERWIJDEREN';

// Progress Tracking
export const PROGRESS_STORAGE_PREFIX = 'progress.v1';

// Theme
export const THEME_LIGHT = 'light';
export const THEME_DARK = 'dark';

// Routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  VERIFY_EMAIL: '/verify-email',
  TOPICS: '/topics',
  PRACTICE: '/practice',
  PROFILE: '/profile',
  TOPIC_PRACTICE: '/topics/:topicId'
};

// Local Storage Keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER: 'user',
  THEME: 'theme',
  SELECTED_TOPIC_ID: 'selected_topic_id',
  SELECTED_TOPIC_NAME: 'selected_topic_name',
  SELECTED_TOPIC_IDS: 'selected_topic_ids'
};

// Analytics Events
export const ANALYTICS_EVENTS = {
  UPGRADE_SHOWN: 'upgrade_shown',
  UPGRADE_CLICKED: 'upgrade_clicked',
  UPGRADE_DISMISSED: 'upgrade_dismissed',
  CHECKOUT_STARTED: 'checkout_started',
  CHECKOUT_FAILED: 'checkout_failed',
  MANAGE_SUBSCRIPTION_CLICKED: 'manage_subscription_clicked'
};

// Custom Events
export const CUSTOM_EVENTS = {
  AUTH_LOGIN: 'auth:login',
  AUTH_LOGOUT: 'auth:logout',
  THEME_CHANGE: 'theme:change'
};
